import styled from 'styled-components';
import Icon from './Icon';
import { forwardRef } from 'react';

export const VideoTour = forwardRef(({ name }, ref) => {
  return (
    <VideoWrapper>
      <video ref={ref} autoPlay muted loop>
        <source src={`${process.env.PUBLIC_URL}/assets/${name}.mp4`} type="video/mp4" />
      </video>
    </VideoWrapper>
  );
});

const VideoWrapper = styled.div`
  width: 100%;
  border-radius: 20px;
  overflow: hidden;
  margin-bottom: 15px;

  video {
    width: 100%;
  }
`;

export const VideoPlaceholder = styled.div`
  height: 235px;
`;

export const Content = styled.div`
  padding: 0 50px;
`;

export const OnboardingStepCommon = styled.div`
  display: flex;
  flex-direction: column;

  ${Icon} {
    width: 38px;
    height: 50px;
    margin: 15px 0;
  }

  h2 {
    text-align: center;
    margin-bottom: 40px;
  }

  p {
    font-family: 'Inter';
    font-style: normal;
    font-weight: 600;
    font-size: 18px;
    color: var(--lizzy-black);
    margin: 0;
  }

  small {
    display: inline-block;
    font-size: 12px;
    color: var(--lizzy-black-65);
    font-weight: 300;

    &.black {
      color: var(--lizzy-black);
    }
  }
`;

export const Blue = styled.span`
  color: var(--lizzy-blue);
`;